import CrossBrandReportsAPI from 'dashboard/api/crossBrandReports';
import camelcaseKeys from 'camelcase-keys';

export const initialState = {
  agents: [],
  accounts: [],
  meta: {},
  agentSessions: {
    sessions: [],
    pagination: {},
  },
  uiFlags: {
    isFetchingAgents: false,
    isFetchingAgentSessions: false,
  },
};

export const getters = {
  getAgents(state) {
    return state.agents;
  },
  getAccounts(state) {
    return state.accounts;
  },
  getMeta(state) {
    return state.meta;
  },
  getAgentSessions(state) {
    return state.agentSessions;
  },
  getUIFlags(state) {
    return state.uiFlags;
  },
};

export const actions = {
  async fetchAgents({ commit }, params) {
    commit('setUIFlags', { isFetchingAgents: true });
    try {
      const response = await CrossBrandReportsAPI.getAgents(params);
      const data = camelcaseKeys(response.data, { deep: true });
      commit('setAgents', data.agents);
      commit('setAccounts', data.accounts);
      commit('setMeta', data.meta);
    } catch (error) {
      // Handle error silently
    } finally {
      commit('setUIFlags', { isFetchingAgents: false });
    }
  },

  async fetchAgentSessions({ commit }, params) {
    commit('setUIFlags', { isFetchingAgentSessions: true });
    try {
      const response = await CrossBrandReportsAPI.getAgentSessions(params);
      const data = camelcaseKeys(response.data, { deep: true });
      commit('setAgentSessions', data);
    } catch (error) {
      // Handle error silently
    } finally {
      commit('setUIFlags', { isFetchingAgentSessions: false });
    }
  },

  clearData({ commit }) {
    commit('setAgents', []);
    commit('setAccounts', []);
    commit('setMeta', {});
    commit('setAgentSessions', { sessions: [], pagination: {} });
  },
};

export const mutations = {
  setAgents(state, agents) {
    state.agents = agents;
  },
  setAccounts(state, accounts) {
    state.accounts = accounts;
  },
  setMeta(state, meta) {
    state.meta = meta;
  },
  setAgentSessions(state, data) {
    state.agentSessions = data;
  },
  setUIFlags(state, uiFlag) {
    state.uiFlags = { ...state.uiFlags, ...uiFlag };
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
